import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/order/list',
    name: 'orderList',
    component: () => import('@/views/apply/order/list'),
    meta: {
      title: i18n.t('router.order.order_list'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/order/detail',
    name: 'orderDetail',
    component: () => import('@/views/apply/order/detail'),
    meta: {
      title: i18n.t('router.order.order_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/order/afterSale/list',
    name: 'afterSaleList',
    component: () => import('@/views/apply/order/afterSale/list'),
    meta: {
      title: i18n.t('router.order.after_sales_orders'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/order/afterSale/detail',
    name: 'afterSaleDetail',
    component: () => import('@/views/apply/order/afterSale/detail'),
    meta: {
      title: i18n.t('router.order.after_sales_order_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/order/comment',
    name: 'commentManagement',
    component: () => import('@/views/apply/order/comment/index'),
    meta: {
      title: i18n.t('router.order.comment_manage'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/order.js